var React = require('react');

function ReportList (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#006A70","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"2","d":"M17 14h5M6 9V5h8c0-1.1.9-2 2-2s2 .9 2 2h8v4M6 9h20M6 9v19c0 .5.421 1 1.0526 1h17.8948C25.5789 29 26 28.5 26 28V9m-13 4-1.9 2-1.1-.8m7 4.8h5m-9 4-1.9 2-1.1-.8m3-6.2-1.9 2-1.1-.8m7 4.8h5"}));
}

ReportList.defaultProps = {"width":"32","height":"32","fill":"none","viewBox":"0 0 32 32"};

module.exports = ReportList;

ReportList.default = ReportList;
